module.exports = __webpack_public_path__ + "static/img/logo-min.5a919fbf.png";